import React from 'react';
import { Moon, Sun, Search, Bell, LogOut } from 'lucide-react';
import { Button } from './ui/button';
interface HeaderProps {
  isDark: boolean;
  toggleDark: () => void;
  onLogout?: () => void;
  userName?: string;
}
export function Header({
  isDark,
  toggleDark,
  onLogout,
  userName
}: HeaderProps) {
  return <header className="sticky top-0 z-10 border-b border-border bg-card" data-id="element-127">
      <div className="flex h-14 items-center gap-4 px-6" data-id="element-128">
        <div className="flex items-center gap-3" data-id="element-129">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/n9wewYGMjUg62LB8s4ZaRK/Download.png" alt="Speedscaling Logo" className="h-8 w-auto" data-id="element-130" />
          <h1 className="text-lg font-semibold text-foreground" data-id="element-131">
            Speedscaling CRM
          </h1>
        </div>

        <div className="flex-1 flex items-center gap-4" data-id="element-132">
          <div className="relative w-full max-w-md" data-id="element-133">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" data-id="element-134" />
            <input type="search" placeholder="Kontakte suchen..." className="w-full h-9 pl-10 pr-4 rounded-lg border border-input bg-background text-foreground placeholder:text-muted-foreground text-sm focus:outline-none focus:ring-2 focus:ring-ring transition-shadow" data-id="element-135" />
          </div>
        </div>

        <div className="flex items-center gap-2" data-id="element-136">
          <Button variant="ghost" size="icon" data-id="element-137">
            <Bell className="h-4 w-4" data-id="element-138" />
          </Button>

          <Button variant="ghost" size="icon" onClick={toggleDark} data-id="element-139">
            {isDark ? <Sun className="h-4 w-4" data-id="element-140" /> : <Moon className="h-4 w-4" data-id="element-141" />}
          </Button>

          {userName && <div className="flex items-center gap-2 pl-2" data-id="element-142">
              <div className="h-8 w-8 rounded-full bg-primary flex items-center justify-center text-primary-foreground text-sm font-medium" data-id="element-143">
                {userName.charAt(0).toUpperCase()}
              </div>
            </div>}

          {onLogout && <Button variant="ghost" size="icon" onClick={onLogout} data-id="element-144">
              <LogOut className="h-4 w-4" data-id="element-145" />
            </Button>}
        </div>
      </div>
    </header>;
}